// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_contact(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "SharingContactClientContactV5",
              "SharingContactFreshContactV5"
            ]);
}

var fragmentConverter = {"__root":{"lastClickedAt":{"b":""},"contact_SharingContactFreshContactV5_email":{"b":""},"contact_SharingContactClientContactV5_email":{"b":""},"contact":{"u":"fragment_contact"}}};

var fragmentConverterMap = {
  fragment_contact: unwrap_fragment_contact
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function sharedPropertyEmailStatsForRecipientEmailStatus_decode($$enum) {
  if ($$enum === "CLICKED" || $$enum === "DELIVERED") {
    return $$enum;
  }
  
}

function sharedPropertyEmailStatsForRecipientEmailStatus_fromString(str) {
  return sharedPropertyEmailStatsForRecipientEmailStatus_decode(str);
}

var Utils = {
  sharedPropertyEmailStatsForRecipientEmailStatus_decode: sharedPropertyEmailStatsForRecipientEmailStatus_decode,
  sharedPropertyEmailStatsForRecipientEmailStatus_fromString: sharedPropertyEmailStatsForRecipientEmailStatus_fromString
};

var node = ((function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedPostEmailStatsSingleRecipient_recipient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "SharingContactClientContactV5",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "SharingContactFreshContactV5",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastClickedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfClicks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "SharedPropertyEmailStatsForRecipient",
  "abstractKey": null
};
})());

var wrap_fragment_contact = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_contact = unwrap_fragment_contact;
exports.wrap_fragment_contact = wrap_fragment_contact;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
